export async function init() {
  console.log('[initialized] footer.ts');
  const footer = document.querySelector('footer');
  if (!footer) return;

  const bottomLinks = footer?.querySelectorAll(
    '.footer__bottom__links-wrapper li',
  );

  const hideBorderInFirstItemsOfLowerRows = () => {
    let firstItemSecondRow: HTMLElement;
    let firstItemThirdRow: HTMLElement;

    // Check if the item is in the second or third row
    bottomLinks?.forEach((link) => {
      const item = link as HTMLElement;
      const itemHeight = item.offsetHeight;
      const itemOffsetTop = item.offsetTop;

      if (
        itemOffsetTop > itemHeight &&
        itemOffsetTop <= 2 * itemHeight &&
        !firstItemSecondRow
      ) {
        firstItemSecondRow = item;
      } else if (itemOffsetTop > 2 * itemHeight && !firstItemThirdRow) {
        firstItemThirdRow = item;
      }
    });

    // Add class to the first element of the second and third row to remove the border
    bottomLinks.forEach((link) => {
      if (link === firstItemSecondRow || link === firstItemThirdRow) {
        link.classList.add('no-border');
      } else {
        link.classList.remove('no-border');
      }
    });
  };

  hideBorderInFirstItemsOfLowerRows();

  window.addEventListener('resize', hideBorderInFirstItemsOfLowerRows);
}
